export default __webpack_public_path__ + "static/mobile_7-8b5cc99f4b92b7af6df055148fd48f18.webp";